export default {
  user: {},
  folders: [],
  news: [],
  videos: [],
  diet: [],
}
